import React, { useEffect } from 'react';
import { useUserInfo, useRequest } from '../../../../../hooks';
import { diagnosisResultAPI } from '../../../../../api/learningNote';
import ResultInfo from '../../aiDiagnosisTest/common/ResultInfo';

function DiagnosisTab() {
  const { info } = useUserInfo();
  const [
    diagnosisResultAPICall,
    result,
  ] = useRequest((data) => diagnosisResultAPI(data));

  useEffect(() => {
    if (!info?.learnerId) return;
    const { learnerId, locale } = info;
    const data = {
      lrnMbrId: learnerId,
      langCd: locale
    }

    diagnosisResultAPICall(data);

  }, []);
  if (!result) return <div></div>
  return (
    <ResultInfo
      result={result}
      type="note"
    />
  );
}

export default DiagnosisTab;